module.exports = __webpack_public_path__ + "img/eng.802641a4.svg";